import "./lib/install-auth-lock";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Recover from stale cached page chunks after a new deploy: reload once.
const RELOAD_KEY = "chunk-reload-at";
const handleChunkError = (message?: string) => {
  if (!message) return;
  if (!/dynamically imported module|Importing a module script failed|Loading chunk/i.test(message)) return;
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  if (Date.now() - last < 10000) return;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
};
window.addEventListener("error", (e) => handleChunkError(e.message));
window.addEventListener("unhandledrejection", (e) =>
  handleChunkError((e.reason as any)?.message || String(e.reason))
);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);